import {  Component, Input, OnInit } from '@angular/core';
import { RegionItem } from '@app/models/compass/RegionItem';

@Component({
    selector: 'app-einurlland',
    templateUrl: './einurlland.component.html',
    styleUrls: ['./einurlland.component.scss'],
    standalone: false
})
export class EinurllandComponent implements OnInit {
    @Input() currentRegionData: RegionItem;
    constructor (
    ) { }

    ngOnInit (): void {
    }
}
